export function getTenantFromHost() {
  const host = window.location.hostname;

  if (host.includes("rienzbeton.it")) return "rb";
  if (host.includes("huberfeichter.it")) return "hf";

  return "hf";
}

export const branding = {
  hf: {
    accent: "#cd071e",
  },
  rb: {
    accent: "#fab724",
  },
};